import styled from 'styled-components';
import { Link } from '../link/link.component.js';

const StyledLink = styled(Link).attrs({
    fontSize: 500,
    type: 'inline',
}) `
  display: inline-flex;
  align-items: center;
`;

export { StyledLink };
